import {inject} from '@angular/core';
import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {filter, map, Observable} from 'rxjs';

import {FacultyAppContextService} from 'libs/shared/faculty/src/lib/service/faculty-app-context.service';
import {hasAccessToCurriculum} from 'libs/shared/permission/src/lib/helpers/has-access-to-curriculum';

export const curriculumGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
    const facultyAppContext = inject(FacultyAppContextService);
    const router = inject(Router);

    return facultyAppContext.contextAccountInformation$.pipe(
        filter((account) => !!account.Account.Permissions),
        map((account) => hasAccessToCurriculum(account.Account) || router.parseUrl('performance'))
    );
};
